module.exports = __webpack_public_path__ + "img/image_1-ada0abf5.png";